<!--
    描述：新增、编辑虚拟组织弹框等
    时间：2020-04-7
    Created by yefan
-->
<template>
    <div class="h100">
        <el-form :model="virtualDeptForm" :rules="virtualDeptRules" ref="virtualDeptForm" label-width="70px">
            <el-row>
                <el-col :span="24">
                    <el-form-item label="虚拟组" prop="sname" :show-message="false">
                        <el-input v-model="virtualDeptForm.sname"
                                  :disabled="isDisabled" autocomplete="off"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-form-item label="上级组织" prop="parentName" :show-message="false">
                        <el-input v-model="virtualDeptForm.parentName"
                                  disabled autocomplete="off"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-form-item label="排序" prop="sort" :show-message="false">
                        <el-input v-model="virtualDeptForm.sort"
                                  :disabled="isDisabled" autocomplete="off"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-form-item label="角色" prop="roleIds" :show-message="false">
                        <tree-select v-model="virtualDeptForm.roleIds"
                                     :options="roleTreeData"
                                     :multiple="true"
                                     :disabled="isDisabled"
                                     :default-expand-level="1"
                                     :append-to-body="true"
                                     placeholder="请选择">
                        </tree-select>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
    </div>
</template>
<script>
    import {selectRoleTree} from '@/api/modules/role.js'
    import {getVirtualDeptInfo, insertVirtualDept} from '@/api/modules/group.js'

    export default {
        props: {
            mode: {
                type: String,
                default: () => {
                    return ''
                }
            },
            virtualDeptInfo: {
                type: Object,
                default: () => {
                    return {}
                }
            },
        },

        data() {
            return {
                roleTreeData: [],
                virtualDeptForm: {
                    sname: '',
                    roleIds: [],
                    parentId: '',
                    parentName: '',
                    sort: '',
                    groupId: ''
                },
                virtualDeptRules: {
                    sname: [{required: true}],
                    roleIds: [{required: true, type: 'array', trigger: 'change'}],
                },
            }
        },

        methods: {
            // 获取角色数据
            getRoleData() {
                let param = {};
                selectRoleTree(param).then(res => {
                    this.roleTreeData = res.data
                })
            },

            //确定按钮事件
            doSave() {
                this.$refs.virtualDeptForm.validate((valid) => {
                    if (valid) {
                        insertVirtualDept(this.virtualDeptForm).then(res => {
                            res.code == 0 ? this.$message.success("保存成功！") : this.$message.error(res.msg);
                            //点击确定后关闭弹框
                            this.$emit('dialogClose')
                        });
                    } else {
                        this.$message.warning("请完善必填项!");
                    }
                });
            },

            // 查看、编辑初始渲染数据
            initVirtualDept() {
                let param = {};
                param.id = this.virtualDeptInfo.id;
                getVirtualDeptInfo(param).then(res => {
                    this.virtualDeptForm = res.data;
                })
            },
        },

        created() {
            this.virtualDeptForm.parentId = (this.virtualDeptInfo) ? this.virtualDeptInfo.id : "0";
            this.virtualDeptForm.parentName = (this.virtualDeptInfo) ? this.virtualDeptInfo.sname : "";
            if (this.mode !== 'add') {
                this.initVirtualDept()
            } else {
                this.virtualDeptForm.groupId = this.virtualDeptInfo.groupId;
            }
            this.getRoleData();
        },

        computed: {
            // 是否可编辑
            isDisabled() {
                return this.mode === 'view' ? true : false
            }
        }
    }
</script>

<style lang="less"></style>
